import '../../tapestry-wc/dist/components/p-DWmaQhSz.js';
import { defineCustomElement } from '../../tapestry-wc/dist/components/tds-page-header.js';

defineCustomElement();
//# sourceMappingURL=index.js.map
